import React, {useState,useEffect} from 'react';
import { TextField, Button, Typography,Paper } from '@material-ui/core';
import FileBase from 'react-file-base64';
import useStyles from './styles';
import {useSelector} from 'react-redux';
import {createPost,updatePost} from '../../actions/posts';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
const Form = ({currentId,setCurrentId}) => {
  //const post = useSelector((state)=>currentId? state.posts.find((p)=>p._id === currentId):null);
  const {posts} = useSelector((state)=> state.posts);
  const post = currentId? posts.find((p)=>p._id===currentId):null;
  const user = JSON.parse(localStorage.getItem('profile'));
  const[postData,setPostData] =useState({title:'',message:'',tags:'',selectedFile:''});
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(()=>{
      if(post) setPostData(post)
  },[post]);
  const clear = () => {
    setCurrentId(0);
    setPostData({ title: '', message: '', tags: '', selectedFile: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    

    if (currentId) {
      
      dispatch(updatePost(currentId, { ...postData, name: user?.result?.name }));
    } else {
      dispatch(createPost({ ...postData, name: user?.result?.name },navigate));
      clear();
    }
  };

  if(!user?.result?.name){
   return (<Paper className={classes.paper}>
      <Typography variant='h6' align='center'>Please Sign in to create your own memories and like other memories</Typography>
    </Paper>
   )}
    
  return (
    <Paper className={classes.paper} elevation={6}>
      <form autoComplete='off' noValidate className={`${classes.form} ${classes.root}`} onSubmit={handleSubmit}>
        <Typography variant="h6">{currentId? 'Editing':'Creating'} a memory</Typography>
        <TextField name="title" variant="outlined"  label="Title" fullWidth value={postData.title} onChange={(e)=>setPostData({...postData,title:e.target.value})} ></TextField>
        <TextField name="message" variant="outlined"  label="Message" fullWidth value={postData.message} onChange={(e)=>setPostData({...postData,message:e.target.value})} ></TextField>
        <TextField name="tags" variant="outlined"  label="Tags" fullWidth value={postData.tags} onChange={(e)=>setPostData({...postData,tags: e.target.value.split(',')})} ></TextField>
        <div className={classes.fileInput}><FileBase type='file' multiple={false} onDone={({base64})=>setPostData({...postData,selectedFile:base64})}/></div>
        <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>
        <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>clear</Button>


      </form>
    </Paper>
  )
}

export default Form